// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__Vi7VW","milestoneBackground":"milestone_milestoneBackground__u+Igl"};